
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DateRangeState {
  start_date: string | null;
  end_date: string | null;
}

const initialState: DateRangeState = {
  start_date: localStorage.getItem("start_date"),
  end_date: localStorage.getItem("end_date"),
};

const dateRangeSlice = createSlice({
  name: "dateRange",
  initialState,
  reducers: {
    setDate(state, action: PayloadAction<DateRangeState>) {
      state.start_date = action.payload.start_date;
      state.end_date = action.payload.end_date;
      localStorage.setItem("start_date", action.payload.start_date || "");
      localStorage.setItem("end_date", action.payload.end_date || "");
    },

  },
});

export const { setDate } = dateRangeSlice.actions;
export default dateRangeSlice.reducer;
